import React from 'react'
import Icon from './Icon'

const URL = props => (
    <span className='text-url'>
        {props.url || props.children}
        {(props.link && (
            <>
                {' '}
                <a target='_blank' rel='noopener noreferrer' href={'https://dereferer.me/?' + escape(props.url || props.children)} className='text-url'>
                    <Icon name='external' className='mr-1' />
                    Visit page
                </a>
            </>
        )) ||
            null}
    </span>
)

export default URL
